import { useState, useCallback } from 'react';

const MIN_ZOOM = 0.6;
const MAX_ZOOM = 2.4;
const ZOOM_STEP = 0.2;

/**
 * Manages zoom state for the PDF viewer.
 *
 * @param {Object}   options
 * @param {Function} options.onZoom - optional analytics callback('in' | 'out')
 * @returns {{ zoom: number, zoomIn: Function, zoomOut: Function }}
 */
const usePdfZoom = ({ onZoom } = {}) => {
  const [zoom, setZoom] = useState(1);

  const zoomIn = useCallback(() => {
    setZoom((z) => Math.min(MAX_ZOOM, +(z + ZOOM_STEP).toFixed(2)));
    if (onZoom) onZoom('in');
  }, [onZoom]);

  const zoomOut = useCallback(() => {
    setZoom((z) => Math.max(MIN_ZOOM, +(z - ZOOM_STEP).toFixed(2)));
    if (onZoom) onZoom('out');
  }, [onZoom]);

  return { zoom, zoomIn, zoomOut };
};

export default usePdfZoom;
